export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  // Parse YYYY-MM-DD directly to avoid UTC→local timezone shift
  const s = dateStr instanceof Date ? dateStr.toISOString() : String(dateStr);
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  // Fallback for other formats
  const d = new Date(dateStr);
  if (isNaN(d)) return '-';
  return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d)) return '-';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount || 0);
};

export const calculateGrade = (marks, maxMarks) => {
  const pct = (marks / maxMarks) * 100;
  if (pct >= 90) return { grade: 'A+', gp: 10, color: 'text-green-600' };
  if (pct >= 80) return { grade: 'A', gp: 9, color: 'text-green-500' };
  if (pct >= 70) return { grade: 'B+', gp: 8, color: 'text-blue-600' };
  if (pct >= 60) return { grade: 'B', gp: 7, color: 'text-blue-500' };
  if (pct >= 50) return { grade: 'C+', gp: 6, color: 'text-yellow-600' };
  if (pct >= 40) return { grade: 'C', gp: 5, color: 'text-yellow-500' };
  if (pct >= 33) return { grade: 'D', gp: 4, color: 'text-orange-500' };
  return { grade: 'F', gp: 0, color: 'text-red-600' };
};

export const generateId = (prefix) => {
  if (prefix === 'PAY') {
    const year = String(new Date().getFullYear()).slice(-2);
    const num = String(Math.floor(1000 + Math.random() * 9000));
    return `${num}-${year}`;
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};
